const oneLinkURL = 'https://easypeasyaf.onelink.me/V0ET';
const mediaSource = { keys: ['utm_source'], overrideValues: { google: 'googleads_int', meta: 'metaweb_int', tiktok: 'tiktokglobal_int' }, defaultValue: 'web_organic' };
const campaign = { keys: ['utm_campaign'], defaultValue: 'website_organic' };
const adSet = { keys: ['utm_term'], defaultValue: 'website_organic_button' };
const ad = { keys: ['utm_content'], defaultValue: 'download_button' };
const channel = { keys: ['utm_medium'], defaultValue: 'own' };
const custom_ss_ui = { paramKey: 'af_ss_ui', defaultValue: 'true' };
const custom_ss_gtm_ui = { paramKey: 'af_ss_gtm_ui', defaultValue: 'true' };

const PARAMS = {
  oneLinkURL,
  afParameters: {
    mediaSource,
    campaign,
    adSet,
    ad,
    channel,
    afCustom: [
      custom_ss_ui,
      custom_ss_gtm_ui
    ]
  }
};

const pickUrl = (result) => {
  if (!result) return null;
  if (typeof result === 'string') return result;
  if (result && typeof result.clickURL === 'string') return result.clickURL;
  return null;
};

export default ({ store }) => {
  if (process.server) return;

  const run = () => {
    try {
      if (typeof window.AF_SMART_SCRIPT_RESULT === 'string') {
        const pre = pickUrl(fromGlobal)
        if (pre) {
          store.commit('smart/setUrl', pre)
          return
        }
      }

      if (window.AF_SMART_SCRIPT && typeof window.AF_SMART_SCRIPT.generateOneLinkURL === 'function') {
        const result = window.AF_SMART_SCRIPT.generateOneLinkURL(PARAMS);
        const url = pickUrl(result);
        if (url) {
          store.commit('smart/setUrl', url);
          return;
        }
      }

      requestAnimationFrame(run);
    } catch (e) {
      store.commit('smart/setError', e);
    }
  }

  run();
};
